import { extractOptionalTranslation } from "./extractOptionalTranslation"
import checkSubVars from "./checkSubVars"
import { IntlShape } from "gatsby-plugin-intl"

export function extractHumanReadableSubVar(
  sourceJson: GeoVarJson | null,
  subVariable: string,
  intl: IntlShape
) {
  if (!sourceJson) {
    return ""
  }
  let subvars = checkSubVars(sourceJson)
  if (!subvars) {
    return ""
  }
  let subvarsMetadata = subvars[subVariable].Metadata.SubVariableName
  return extractOptionalTranslation({
    parentKey: "subVariableNames",
    subKey: subvarsMetadata,
    intl,
  })
}
